<template>
  <div :class="{ 'q-col-12 q-col-md-9 q-pt-1': showQueriesSection, 'q-col-12 q-pt-1': !showQueriesSection}"
       class="on-focus__popular-products q-pt-1">
    <ProductsContainer
        :sectionEnabled="popularProductsEnabled"
        :promotedProductEnabled="topProductEnabled"
        :promotedProductHeader=" SmartSearchTranslations.popularProducts.topProductHeader"
        :promotedProduct="getTopProduct"
        :productsHeader="SmartSearchTranslations.popularProducts.header"
        :productsList="popularProducts"
        :canShowPromotedSection="topProductEnabled"
    />
  </div>
</template>
<script lang="ts" setup>
import ProductsContainer from '@/components/AutocompletePopup/Products/ProductsContainer.vue'

import {inject, onMounted} from "vue";
import {storeToRefs} from "pinia";
import {usePopularProductsStore} from "@/store/AutocompletePopup/PopularProductsStore";
import {SmartSearchTranslationsInterface} from "@/core/types";

const popularProductStore = usePopularProductsStore()

const SmartSearchConfig = inject('SmartSearchConfig').value;

const popularQueriesEnabled = SmartSearchConfig.onfocus.popularQueries.enabled
const {enabled, sections} = SmartSearchConfig.onfocus.predefinedQueries
const showPredefinedQueries = sections.length > 0 && enabled
const popularProductsEnabled = SmartSearchConfig.onfocus.popularProducts.enabled
const topProductEnabled = SmartSearchConfig.onfocus.topProduct.enabled
const recentQueriesEnabled = SmartSearchConfig.onfocus.recentQueries.enabled

const showQueriesSection = popularQueriesEnabled || showPredefinedQueries || recentQueriesEnabled

const {getTopProduct, getPopularProducts, getPopularProductsWithoutFirst} = storeToRefs(popularProductStore)
const popularProducts = topProductEnabled ? getPopularProductsWithoutFirst : getPopularProducts
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SmartSearchTranslations = inject<SmartSearchTranslationsInterface>('SmartSearchTranslations')!

onMounted(async () => {
  await popularProductStore.fetchPopularProducts()
})
</script>